import { Flex } from '@servicetitan/anvil2';
import { Message } from '../../common/components/Message';
import emptyFolder from './empty-folder.svg';

export const NoPlansAvailableState = () => {
    return (
        <Flex direction="column" alignItems="center" justifyContent="center" gap="6">
            <img src={emptyFolder} />
            <Message
                headline="No plans available"
                detail="Try editing your financing information and searching again."
            />
        </Flex>
    );
};
